module.exports = __webpack_public_path__ + "static/img/sjzt.d7253b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjzt.png
// module id = bCmF
// module chunks = 0